function parseAkamaiHeader(headerString, {
  delimiter
}) {
  // Return empty object if headerString is empty
  if (!headerString) {
    return {};
  }
  return headerString.split(delimiter).map(pair => {
    const parts = pair.split('=');
    return [parts[0], parts[1] || ''];
  }).reduce((acc, val) => {
    const key = val[0].trim();
    acc[key] = val[1].trim();
    return acc;
  }, {});
}

export { parseAkamaiHeader };
